import Navbar from "@/src/free-assessment/_components/Navbar";
import { registerCompanySchema, RegisterCompany } from "@/schema/RegisterCompany";
import RegisterCompanyForm from "@/src/register-company/_components/RegisterCompanyForm";
import RegisterCompanyActionButtons from "@/src/register-company/_components/RegisterCompanyActionButtons";
import { zodResolver } from "@hookform/resolvers/zod";
import { FormProvider, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import { useTurnstileToken } from "@/hooks/useTurnstileToken";

function RegisterCompanyPage() {
  const { t } = useTranslation();
  const methods = useForm<RegisterCompany>({
    resolver: zodResolver(registerCompanySchema),
    defaultValues: {
      plan_selection: "assessment-with-consult",
      agree_to_terms: false,
      cf_turnstile_response: "",
    },
  });

  const {
    ref: turnstileRef,
    token: turnstileToken,
    isReady: isTurnstileReady,
    isLoading: isTurnstileLoading,
    error: turnstileError,
    reset: resetTurnstile,
  } = useTurnstileToken();

  useEffect(() => {
    methods.setValue("cf_turnstile_response", turnstileToken ?? "", {
      shouldValidate: false,
    });
  }, [methods, turnstileToken]);

  return (
    <div className="h-full min-h-full overflow-y-auto bg-cool-gray-50">
      <Navbar />
      <FormProvider {...methods}>
        <div className="pt-16">
          <div className="px-6 pt-10 text-center">
            <div className="text-3xl font-semibold text-cool-gray-900">
              {t("register-company-title")}
            </div>
            {/* <div className="mt-2 text-sm text-cool-gray-600">
              {t("register-company-subtitle")}
            </div> */}
          </div>
          <RegisterCompanyForm
            turnstileRef={turnstileRef}
            turnstileError={turnstileError}
          />
        </div>
        <RegisterCompanyActionButtons
          turnstileToken={turnstileToken}
          isTurnstileReady={isTurnstileReady}
          isTurnstileLoading={isTurnstileLoading}
          resetTurnstile={resetTurnstile}
        />
      </FormProvider>
    </div>
  );
}

export default RegisterCompanyPage;
